import { AccountCalendarModel } from './../models/account-calendar.model';
import { RegionModel } from './../models/region.model';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { InfraService } from './infra.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccountingCalendarService {

  private configUrl: string;
  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint2 + 'accountingcalendar';
    });
  }
  public getAccountingCalendar(): Observable<AccountCalendarModel[]> {
    return this.http.get<RegionModel[]>(`${this.configUrl}/getAccountingCalendar`);
    // .catch(this.handleError);
  }
  private handleError(error: Response) {
    return throwError(()=> error);
  }


}
